import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    challengeprofileList : [],
    selectedChallengeProfile:{},
}
const challengeProfileSlice = createSlice({
    name:'challengeprofile',
    initialState,
    reducers:{
        setChallengeProfileList:(state,{payload})=>{
            state.challengeprofileList = payload
        },
        setSelectedChallengeProfile:(state,{payload})=>{
            state.selectedChallengeProfile = payload
        },
    }
})

export const { setChallengeProfileList,setSelectedChallengeProfile} = challengeProfileSlice.actions
export default challengeProfileSlice.reducer